import s from '../allservices.jsx'
import { toast } from 'react-toastify';
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth.js'

const getAlertService = (actionCallback,cardDetailsId) => {
    let token = "Token " + localStorage.getItem('token')
    let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
    const state = {
          applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
          cardDetailsId: cardDetailsId,
      }
    let traceId = getClientId();
    fetch(plink + s.get_cardPreferance, {
        method: "POST",
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token,
            'X-Trace-Id': traceId,
            'X-KlickEx-Client':buildClientHeader(),
        }),
        body: JSON.stringify(state)
    })
        .then(res => {
            if (res.status === 200 || res.status === 201 || res.status === 204 || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
            } 
            else if (res.status === 401) {
           
                //     localStorage.clear();
                //     this.props.history.push("/")
                let errorOut= "logout"
                actionCallback(errorOut)
                } else {
                // 
                actionCallback(res.headers.get('message'),"error")
                toast.error(res.headers.get('message'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 2000,
                    newestOnTop: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                }); 
            }
        })
}

export default getAlertService;


// WEBPACK FOOTER //
// ./src/services/components/get_cardpreferance.jsx